import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authFetch } from "../../utils/api";
import '../../styles/admin/admin-form.css'; 

const INITIAL_DATA = {
  nombre: '',
  direccion: '' // CAMBIO: Ahora manejamos dirección
};

export default function FormularioEstacion() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id); 

  const [formData, setFormData] = useState(INITIAL_DATA);
  const [pageLoading, setPageLoading] = useState(isEditMode);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isEditMode) {
      setPageLoading(true);
      setError(null);
      
      authFetch(`/api/Estaciones/${id}`)
        .then(res => {
          if (!res.ok) throw new Error('No se pudo cargar la estación.');
          return res.json();
        })
        .then(data => {
          setFormData({
            nombre: data.nombre || '',
            direccion: data.direccion || '' // CAMBIO: Cargar dirección existente
          });
        })
        .catch(err => {
          setError(err.message);
        })
        .finally(() => setPageLoading(false));
    }
  }, [id, isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    const url = isEditMode
      ? `/api/Estaciones/${id}`
      : `/api/Estaciones`;
      
    const method = isEditMode ? 'PUT' : 'POST';

    const payload = {
      ...(isEditMode && { id }),
      nombre: formData.nombre,
      direccion: formData.direccion // CAMBIO: Enviamos la dirección al backend
    };
    
    try {
      const response = await authFetch(url, {
        method: method,
        body: JSON.stringify(payload), 
      });

      if (!response.ok) {
        const errorText = await response.text(); 
        throw new Error(errorText || 'Error al guardar.');
      }

      alert(isEditMode ? 'Estación actualizada (Coordenadas recalculadas)' : 'Estación creada');
      navigate('/admin/estaciones');
    } catch (err) {
      setError(err.message);
      alert('Error: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      <button className="btn-back" onClick={() => navigate(-1)} disabled={isSubmitting}>
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
        Volver
      </button>

      <h1>{isEditMode ? 'Editar Estación' : 'Nueva Estación'}</h1>

      {error && <div className="form-error">Error: {error}</div>}

      {pageLoading ? (
        <div className="form-loading">Cargando datos...</div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Nombre de la Estación (*)</label>
            <input
              id="nombre"
              name="nombre"
              type="text"
              placeholder="Ej. Estación Central"
              value={formData.nombre}
              onChange={handleChange}
              disabled={isSubmitting}
              required
            />
          </div>

          {/* CAMBIO: Input de Dirección con ayuda de formato */}
          <div className="form-group">
            <label htmlFor="direccion">Dirección Completa (*)</label>
            <input
              id="direccion"
              name="direccion"
              type="text"
              placeholder="Ej. Av. Insurgentes Sur 123, CDMX, México"
              value={formData.direccion}
              onChange={handleChange}
              disabled={isSubmitting}
              required
            />
            <small style={{ color: '#666', marginTop: '5px', display: 'block', fontSize: '0.9em' }}>
              ℹ️ Para asegurar la ubicación correcta en el mapa, utiliza el formato: <br/>
              <b>Calle y Número, Colonia/Barrio, Ciudad, Estado, País.</b>
            </small>
          </div>

          <button 
            type="submit" 
            className="btn-submit" 
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Guardando y Calculando Ubicación...' : 'Guardar Estación'}
          </button>
        </form>
      )} 
    </div>
  );
}